module.exports = __webpack_public_path__ + "89db1891b4b2008b41613a7ff15d77e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/rg_logo.png
// module id = 1201
// module chunks = 0